var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rewardData)?_c('div',{staticClass:"base-reward align-items-center",class:[
    _vm.displayInline ? 'd-inline-flex' : 'd-flex flex-column',
    _vm.isKingspass ? 'kingspass-reward' : 'normal-reward',
    `base-${_vm.rewardType}`,
  ]},[_c('div',{staticClass:"reward-icon bg-img",class:`${_vm.rewardType}-reward`,style:({ 'background-image': 'url(' + _vm.assetUrl + ')' })}),_c('div',{staticClass:"reward-amount d-inline-flex"},[_c('div',{staticClass:"amount-number"},[_vm._v(" "+_vm._s(_vm.formattedRewardAmount)+" ")]),(_vm.rewardSuffix)?_c('div',{staticClass:"amount-suffix"},[_vm._v(" "+_vm._s(_vm.rewardSuffix)+" ")]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }